export const CLIENT =
  process.env.REACT_APP_ENV_VAR?.trim() === 'simulated' ||
  process.env.NODE_ENV?.trim() === 'test'
    ? '@client'
    : '';
